import Home from "../view/Home";
 

export const HomeRoutes =[
    {
        path:"/",
        element: <Home/>
    },
   
];